import { render, staticRenderFns } from "./AttachStatement.vue?vue&type=template&id=737fa125&"
import script from "./AttachStatement.vue?vue&type=script&lang=js&"
export * from "./AttachStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports